<template>
  <div>
    <div class="content" style="font-size: 1.1rem">
      <div class="row justify-content-md-center">
        <amplify-authenticator>
          <amplify-sign-in
            slot="sign-in"
            header-text="Sign in to Cedience"
            hide-sign-up="true"
          ></amplify-sign-in>
        </amplify-authenticator>
      </div>
    </div>
  </div>
</template>

<script>
import { Hub } from 'aws-amplify';
import { mapGetters } from 'vuex';
import { oldSnippetsBackfill } from '../utils/oldSnippetsBackfill';

export default {
  name: 'Login',
  computed: {
    ...mapGetters(['modalProject']),
  },
  created() {
    const listener = (data) => {
      switch (data.payload.event) {
        case 'signIn':
          this.$store.dispatch('FETCH_USER').then(() => {
            oldSnippetsBackfill();
            localStorage.setItem('projectModal', true);
            this.$router.push({ name: 'ProjectSearchDocsDashboard' });
          });
          break;
      }
    };
    Hub.listen('auth', listener);
  },
};
</script>
